import { threadLinkMatchesPath } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/threadLinkMatchesPath.js';
import { isAutomationRoutePath } from '#pplx/frontend/apps/ask/queries/automation-queries/automationRunRoute.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useSearchParams } from '#pplx/frontend/router/useSearchParams.js';
import { useCallback } from 'react';
export function sessionIsSelected(href, pathname, searchParams) {
    if (!href || !pathname)
        return false;
    const [path = '', query = ''] = (href.split('#')[0] ?? '').split('?');
    if (path === '/computer/automations' || path.startsWith('/computer/automations/')) {
        const automationId = new URLSearchParams(query).get('automationId');
        return Boolean(automationId &&
            (isAutomationRoutePath(pathname, automationId) ||
                (path === pathname && searchParams?.get('automationId') === automationId)));
    }
    return path === pathname || threadLinkMatchesPath(path, pathname);
}
export function useSessionIsSelected() {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    return useCallback((href) => sessionIsSelected(href, pathname, searchParams), [pathname, searchParams]);
}
//# sourceMappingURL=sessionItems.js.map